import { createFileRoute } from '@tanstack/react-router'
import { Settings2Icon } from 'lucide-react'

import { UnderConstructionPage } from '@/components/under-construction'

export const Route = createFileRoute('/_dashboard/site/$id/heat-pump/mode/')({
  component: () => <UnderConstructionPage titleKey="dashboard.sidebar.modeChoice" icon={<Settings2Icon className="size-6" />} />,
})
